import { render, staticRenderFns } from "./base-data.vue?vue&type=template&id=7a55bc5e&scoped=true"
import script from "./base-data.vue?vue&type=script&lang=js"
export * from "./base-data.vue?vue&type=script&lang=js"
import style0 from "./base-data.vue?vue&type=style&index=0&id=7a55bc5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55bc5e",
  null
  
)

export default component.exports